import React, { useState, useEffect } from "react";
import Container from "@mui/material/Container";
import Bottomright from "../assets/images/first-page/bottom-right-gradient.svg";
import Topleft from "../assets/images/first-page/top-left-gradient.svg";
import {
  TextField,
  Button,
  IconButton,
  Typography,
  Box,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  Stack,
} from "@mui/material";
import Logo from "../assets/images/common/logo.png";

import Chatgpt from "../assets/images/common/chatgpt-logo.png";
import Gemini from "../assets/images/common/gemini-logo.png";
import Gemma from "../assets/images/common/gemma-logo.png";
import Mistral from "../assets/images/common/mistral-logo.png";
import Websearch from "../assets/images/common/web-search-logo.png";
import Tick from "../assets/images/common/tick-icon.png";
import { Selectedchatbot, ModelSelection, resetChat } from "../redux/chatslice";
import Grid from "@mui/material/Grid2";
import { useDispatch, useSelector } from "react-redux";
import { decryptUserId } from "../utilis/encrypto";
import { useNavigate } from "react-router-dom";
import { useTheme } from '@mui/material/styles';
// import base_url from "../commanimage";
import {base_url} from "../constant";

function Welcome() {
  const theme = useTheme();
  const [textGeneration, setTextGeneration] = useState([]);
  const [imageGeneration, setImageGeneration] = useState([]);
  const [SelectedTextModels, setSelectedTextModels] = useState([]);
  const [selectedImageModels, setSelectedImageModels] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);

  const { model } = useSelector((state) => state.chat);
  const { issuccess } = useSelector((state) => state.chat);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleActive = (id) => {
    const updatedTextGeneration = textGeneration.map((element) => {
      if (element.id === id) {
        return { ...element, isSelected: !element.isSelected };
      }
      return element;
    });

    const activeTextIds = updatedTextGeneration
      .filter((element) => element.isSelected)
      .map((element) => element.id.toString());

    setSelectedTextModels(activeTextIds);
    setTextGeneration(updatedTextGeneration);
    setSelectedImageModels([]); 
    setImageGeneration(imageGeneration.map((ele) => ({ ...ele, isSelected: false })));
  };

  const handleActiveImage = (id) => {
    const updatedImageGeneration = imageGeneration.map((element) => {
      if (element.id === id) {
        return { ...element, isSelected: !element.isSelected };
      }
      return element;
    });

    const activeImageIds = updatedImageGeneration
      .filter((element) => element.isSelected)
      .map((element) => element.id.toString());

    setSelectedImageModels(activeImageIds);
    setImageGeneration(updatedImageGeneration);
    setSelectedTextModels([]);
    setTextGeneration(textGeneration.map((ele) => ({ ...ele, isSelected: false })));
  };

  // Function to update selected IDs from both text and image models
  const updateSelectedIds = (textIds) => {
    const mergedIds = [...new Set([...textIds])];
    setSelectedIds(mergedIds);
  };

  // Handle Save Function
  const handleSave = () => {
    const encryptedUserId = localStorage.getItem("userId");
    const userId = decryptUserId(encryptedUserId);

    if (!userId) {
      console.error("Failed to decrypt user ID.");
      return;
    }
    const selectedIds = SelectedTextModels.length > 0 ? SelectedTextModels : selectedImageModels;

    const payload = {
      user_id: userId,
      selected: selectedIds,
    };

    dispatch(Selectedchatbot(payload));
  };

  // Fetch the models on component load
  useEffect(() => {
    dispatch(ModelSelection());
  }, [dispatch]);

  useEffect(() => {
    if (model.text_model?.length > 0) {
      const activeTextIds = model.text_model
        .filter((element) => element?.isSelected)
        .map((element) => element.id.toString());
      setSelectedTextModels(activeTextIds);
      setTextGeneration(model.text_model);
      updateSelectedIds(activeTextIds);
    }
  }, [model.image_model]);

  useEffect(() => {
    if (model.image_model?.length > 0) {
      const activeImageIds = model.image_model
        .filter((element) => element?.isSelected)
        .map((element) => element.id.toString());
      setSelectedImageModels(activeImageIds);
      setImageGeneration(model.image_model);
      // updateSelectedIds(SelectedTextModels, activeImageIds);
    }
  }, [model.image_model]);

  // Redirect to the chat page after saving
  useEffect(() => {
    if (issuccess) {
      navigate("/chat");
    }
  }, [navigate, issuccess]);
  return (
    <>
      <Box
        className="welcome-page"
        sx={{ position: "relative", zIndex: "9999" }}
      >
        <Container>
          <Stack
            direction={"column"}
            justifyContent={"start"}
            alignItems={"start"}
          >
            <Box>
              <img src={Logo} alt="logo" />
            </Box>

            <Box sx={{ width: {xs:'100%', md:"40%"}, paddingTop: { xs: "40px", xl: "80px" } }}>
              <Typography
                variant="h1"
                sx={{ color: "#fff", fontSize: {xs:'28px', md:"40px"}, fontWeight: "700" }}
                fullWidth
              >
                Welcome to Asklms App
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: "#CBD2E2",
                  fontSize: "16px",
                  fontWeight: "500",
                  mt: { xs: "4px", xl: "12px" },
                  mb: { xs: "12px", xl: "28px" },
                }}
              >
                Please select your preferred LLM model to get answers. You can
                change your preferences anytime from setting screen
              </Typography>
            </Box>

            <Box sx={{ width: "100%", paddingTop: { xs: "30px", xl: "60px" } }}>
              <Typography
                variant="h1"
                sx={{
                  color: "#fff",
                  fontSize: {xs:'20px', md:"24px"},
                  fontWeight: "700",
                  mb: { xs: "14px", xl: "24px" },
                }}
                fullWidth
              >
                Text Generation
              </Typography>
              <Grid container spacing={"24px"}>
                {textGeneration &&
                  textGeneration.map((ele) => (
                    <Grid key={ele.id} size={{ xs: 6, md: 2 }}>
                      <Stack
                        onClick={() => handleActive(ele.id)}
                        justifyContent={"center"}
                        alignItems={"center"}
                        sx={{
                          width: "100%",
                          height: "100%",
                          position: "relative",
                          p: { xs: "16px", md: "24px", xl: "38px" },
                          borderRadius: "12px",
                          border: "1px solid #2E3852",
                          background: ele.isSelected
                          ? theme.palette.primary.main
                          : theme.palette.greyshades.grey100,
                          //   background: "#1B2338",
                          //   "& > .child": {
                          //     display: "none",
                          //   },

                          //   "&:hover .child": {
                          //     display: "block",
                          //   },
                          //   "&:hover": {
                          //     backgroundColor: "primary.main",
                          //   },
                        }}
                      >
                        <img src={`${base_url}/${ele.image}`} alt="logo" />

                        <Box
                          sx={{
                            position: "absolute",
                            top: "6px",
                            right: "12px",
                          }}
                          className="child"
                        >
                          {ele.isSelected ? (
                            <img src={Tick} alt="tick-icon" />
                          ) : (
                            ""
                          )}
                        </Box>
                      </Stack>
                    </Grid>
                  ))}
              </Grid>
            </Box>

            <Box sx={{ width: "100%", paddingTop: { xs: "30px", xl: "60px" } }}>
              <Typography
                variant="h1"
                sx={{
                  color: "#fff",
                  fontSize: {xs:'20px', md:"24px"},
                  fontWeight: "700",
                  mb: { xs: "14px", xl: "24px" },
                }}
                fullWidth
              >
                Image Generation
              </Typography>

              <Grid container spacing={"24px"}>
                {imageGeneration &&
                  imageGeneration.map((ele) => (
                    <Grid key={ele.id} size={{ xs: 6, md: 2 }}>

                      <Stack
                        onClick={() => handleActiveImage(ele.id)}
                        justifyContent={"center"}
                        alignItems={"center"}
                        sx={{
                          width: "100%",
                          height: "100%",
                          position: "relative",
                          p: { xs: "16px", md: "24px", xl: "38px" },
                          borderRadius: "12px",
                          border: "1px solid #2E3852",
                          background: ele.isSelected
                          ? theme.palette.primary.main
                          : theme.palette.greyshades.grey100,
                          //   background: "#1B2338",
                          //   "& > .child": {
                          //     display: "none",
                          //   },

                          //   "&:hover .child": {
                          //     display: "block",
                          //   },
                          //   "&:hover": {
                          //     backgroundColor: "primary.main",
                          //   },
                        }}
                      >
                        <img src={`${base_url}/${ele.image}`} alt="logo" />

                        <Box
                          sx={{
                            position: "absolute",
                            top: "6px",
                            right: "12px",
                          }}
                          className="child"
                        >
                          {ele.isSelected ? <img src={Tick} alt="tick-icon" /> : ""}
                        </Box>

                      </Stack>
                    </Grid>
                  ))}
              </Grid>
            </Box>

            <Box sx={{ pt: { xs: "50px", xl: "100px" } }}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{
                  mb: { xs: 0, xl: 2 },
                  p: { xs: "10px", xl: "15px" },
                  width: "200px",
                  backgroundColor: "primary.Main",
                  fontSize: "18px",
                  fontWeight: "500",
                  borderRadius: "50px",
                  height: "auto",
                }}
                onClick={() => handleSave()}
              >
                Save
              </Button>
            </Box>
          </Stack>
        </Container>

        <Box sx={{
          position: "absolute", top: 0, left: 0, zIndex: "-1", "& > .child": {
            width: { xs: '300px', md: 'auto' },
          },
        }}>
          <img src={Topleft} alt="gradient" className="child" />
        </Box>
        <Box sx={{
          position: "absolute", bottom: 0, right: 0, zIndex: "-1", "& > .child": {
            width: { xs: '300px', md: 'auto' },
          },
        }}>
          <img src={Bottomright} alt="gradient" className="child" />
        </Box>

      </Box>
    </>
  );
}

export default Welcome;